import Index from '@/views/members/Index'

export default [
  {
    path: ':clientId/users',
    name: 'members.index',
    component: Index
  }
]
